import React, { Component } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import ReportButtonGroup from "../../commoncomponents/reportButtonGroup";
import TimeZoneConvert from "../../../utils/timeZoneConvert";
import "../../../styles/reports/reports.scss";
import "../../../styles/tools/colors.scss";
import { Button } from "react-bootstrap";
import Calendar from "react-calendar/dist/umd/Calendar";
import {
  setLoadingPage,
  setErrorMessage,
  setHeaderVisible,
  setReportAssetId,
  setReportCalendatDate,
  setReportAssetName,
  setReportGroupId,
} from "../../../reducers/actions";
import { connect } from "react-redux";
import Select from "react-select";
import Summary from "../common/summary";
import OverSpeedException from "./overspeedExceptions";
import RawMessagesEvents from "./rawMessagesEvents";
import axios from "axios";
import { apiHost } from "../../../api/apiClient";
import moment from "moment";
import VisitLog from "./visitLog";
import VisitMap from "../../maps/visitMap";
import GridLoader from "react-spinners/GridLoader";
import AssetInforWarning from "../../commoncomponents/assetInforWarning";
import GroupWarning from "../../commoncomponents/groupWarning";
import queryString from "query-string";
import { GetLocationAddress } from "../../../utils/mapapi";

const REPORT_FILTERING_STORAGE_KEY = "reportUseFiltering";

const getSavedReportFilteringState = () => {
  const savedValue = localStorage.getItem(REPORT_FILTERING_STORAGE_KEY);
  return savedValue === null ? true : savedValue !== "false";
};

const getReportFilteringQueryValue = (values) => {
  const queryValue = values.UseFiltering || values.useFiltering || values.filtering;
  if (queryValue === undefined) {
    return null;
  }

  const normalisedValue = String(queryValue).toLowerCase();
  return normalisedValue !== "false" && normalisedValue !== "0";
};

class Visit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetPlaceholder: "Select Asset",
      dataPlaceholder: moment().format("dddd Do MMMM, YYYY"),
      groupCustomerName: "",
      groupGeneralName: "",
      assetCustomerName: "",
      assetGeneralName: "",
      ReportDate: moment().format("YYYY-MM-DD"),
      calendarSelectedDate: new Date(),
      calendarShow: false,
      checked: getSavedReportFilteringState(),
      groupDetails: [],
      groupId: "",
      AssetList: [],
      assetId: "",
      reportDetails: [],
      assetLoader: true,
      reportLoader: false,
      generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
      assetSelectionBoolean: false,
      visitMapPoints: [],
      subTripPoints: [],
      errorLoader: false,
      errorMessage: "",
      isLoading: false,
      loadedReportParams: null,
    };
    this.groupId = "";
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  async componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    const searchDate = values.assetDate || values.SearchDate || values.searchDate;
    const assetId = values.assetId || values.AssetId || values.id;
    const assetName = values.assetName || values.AssetName || values.name || "Selected Asset";
    const groupId = values.groupId || values.GroupId;
    const useFiltering = getReportFilteringQueryValue(values);
    const urlState = {};

    if (useFiltering !== null) {
      urlState.checked = useFiltering;
      localStorage.setItem(REPORT_FILTERING_STORAGE_KEY, String(useFiltering));
    }

    if (groupId) {
      this.groupId = groupId;
      urlState.groupId = groupId;
      urlState.assetLoader = true;
      this.props.setReportGroupIdAction(groupId);
      this.getAssets(groupId);
    }

    if (assetId) {
      if (searchDate !== undefined && searchDate !== "null") {
        urlState.dataPlaceholder = moment(searchDate).format("dddd Do MMMM, YYYY");
        urlState.ReportDate = searchDate;
        urlState.calendarSelectedDate = moment(searchDate).toDate();
      }

      urlState.assetPlaceholder = assetName;
      urlState.assetCustomerName = assetName;
      urlState.assetId = assetId;
      this.setState(urlState, this.handleCreateReport);
    } else if (Object.keys(urlState).length > 0) {
      this.setState(urlState);
    }
    try {
      let GroupList = await axios.post(
        `${apiHost}/api/Notification/AllGroupForNotification`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      if (GroupList.status === 200) {
        this.setState({ isLoading: false, groupDetails: GroupList.data });
      } else {
        this.setState({ isLoading: true });
      }
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ calendarShow: false });
    }
  }

  getAssets = async (groupId) => {
    try {
      let AssetList = await axios.get(`${apiHost}/api/Notification/AssetsByGroupId/${groupId || this.groupId}?IsReport=true`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({
        AssetList: AssetList.data.paggedlist,
        assetLoader: false,
      });
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleGroupSelection = (selectedGroup) => {
    if (!selectedGroup) {
      this.groupId = "";
      this.setState({
        groupId: "",
        groupCustomerName: "",
        groupGeneralName: "",
        assetCustomerName: "",
        assetGeneralName: "",
        assetPlaceholder: "Select Asset",
        assetId: "",
        AssetList: [],
        assetLoader: false,
      });
      this.props.setReportGroupIdAction("");
      return;
    }

    const group = selectedGroup.data;
    this.groupId = group.groupId;
    this.setState({
      groupId: group.groupId,
      groupCustomerName: group.customername,
      groupGeneralName: group.groupName,
      assetCustomerName: "",
      assetGeneralName: "",
      assetPlaceholder: "Select Asset",
      assetId: "",
      AssetList: [],
      assetLoader: true,
    });
    this.props.setReportGroupIdAction(group.groupId);
    this.getAssets(group.groupId);
  };

  handleAssetSelection = (selectedAsset) => {
    if (!selectedAsset) {
      this.setState({
        assetId: "",
        assetCustomerName: "",
        assetGeneralName: "",
        assetPlaceholder: "Select Asset",
      });
      return;
    }

    const asset = selectedAsset.data;
    this.setState({
      assetId: asset.assetId,
      assetCustomerName: asset.name,
      assetGeneralName: asset.customerName,
      assetPlaceholder: asset.name,
    });
  };

  calendarFunction = () => {
    this.setState({
      calendarShow: !this.state.calendarShow,
    });
  };

  onChangeDate = (date) => {
    this.setState({
      calendarSelectedDate: date,
      ReportDate: moment(date).format("YYYY-MM-DD"),
      dataPlaceholder: moment(date).format("dddd Do MMMM, YYYY"),
      calendarShow: false,
    });
  };

  handleCheckup = () => {
    this.setState((prevState) => {
      const checked = !prevState.checked;
      localStorage.setItem(REPORT_FILTERING_STORAGE_KEY, String(checked));
      return { checked };
    });
  };

  handleWindow = () => {
    this.props.setHeaderVisibleAction(!this.props.headerHide);
  };

  getQuickReportUrl = (path) => {
    const assetName = this.state.assetCustomerName || this.state.assetPlaceholder || "";
    const params = new URLSearchParams({
      assetId: this.state.assetId,
      assetName,
      SearchDate: this.state.ReportDate,
      assetDate: this.state.ReportDate,
      UseFiltering: String(this.state.checked),
    });

    if (this.state.groupId) {
      params.set("groupId", this.state.groupId);
    }

    return `${path}?${params.toString()}`;
  };

  openQuickReport = (path) => {
    if (!this.state.assetId) {
      return;
    }

    const href = this.getQuickReportUrl(path);
    const parentWindow = window.opener && !window.opener.closed ? window.opener : window;
    const reportWindow = parentWindow.open(href, "_blank");

    if (reportWindow) {
      reportWindow.focus();
      return;
    }

    window.open(href, "_blank");
  };

  updateCurrentReportUrl = () => {
    const href = this.getQuickReportUrl(this.props.location.pathname);
    this.props.history.replace(href);
  };

  handleCreateReport = async () => {
    const assetID = this.state.assetId;
    const assetName = this.state.assetCustomerName || this.state.assetPlaceholder;

    if (!assetID) {
      this.setState({
        assetSelectionBoolean: false,
        errorLoader: true,
        reportLoader: false,
        errorMessage: "Select an asset before creating the Visit report.",
      });
      return;
    }

    this.setState({
      reportDetails: [],
      visitMapPoints: [],
      subTripPoints: [],
      assetSelectionBoolean: true,
      reportLoader: true,
      errorLoader: false,
      errorMessage: "",
      generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
    });

    this.props.setReportAssetIdAction(assetID);
    this.props.setReportAssetNameAction(assetName);
    this.props.setReportCalendatDateAction(this.state.ReportDate);
    this.props.setReportGroupIdAction(this.state.groupId);
    this.updateCurrentReportUrl();
    this.setState({
      loadedReportParams: {
        assetId: this.state.assetId,
        reportDate: this.state.ReportDate,
        groupId: this.state.groupId,
        checked: this.state.checked,
      },
    });

    try {
      let ReportDetails = await axios.post(
        `${apiHost}/api/Report/Visit`,
        {
          AssetId: assetID,
          SearchDate: this.state.ReportDate,
          Timezone: localStorage.getItem("timeZoneID"),
          UseFiltering: this.state.checked,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({
        reportLoader: false,
        errorLoader: false,
      });

      this.setState({ reportDetails: ReportDetails.data });

      const assetMapDay = ReportDetails.data.assetMapDay || {};
      const mapObjects = assetMapDay.mapObjects || [];
      const tripMapObjects = assetMapDay.tripMapObjects || [];

      if (mapObjects.length > 0 || tripMapObjects.length > 0 || assetMapDay.startPosition || assetMapDay.endPosition) {
        this.setVisitMapPoints(mapObjects, assetMapDay.startPosition, assetMapDay.endPosition, tripMapObjects);
      }

      if (tripMapObjects.length > 0) {
        await this.SetAddress(tripMapObjects);
        this.setSubVisitPoints(tripMapObjects);
      }
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
      const responseMessage = e.response && e.response.data
        ? (typeof e.response.data === "string" ? e.response.data : JSON.stringify(e.response.data))
        : "No Data Available";
      this.setState({
        reportLoader: false,
        errorLoader: true,
        errorMessage: responseMessage,
      });
    }
  };

  SetAddress = async (data) => {
    const newsubtriparray = await Promise.all(
      data.map(async (item) => {
        if (!item.address && item.lastMessage && item.lastMessage.gPRMC) {
          item.address = await GetLocationAddress(item.lastMessage.gPRMC.latitude, item.lastMessage.gPRMC.longitude);
        }
        return item;
      })
    );
    return newsubtriparray;
  };

  setSubVisitPoints = (data) => {
    var subTripPoints = [];
    data.forEach((element) => {
      if (element.lastMessage != null) {
        const obj = {
          lat: element.lastMessage.gPRMC.latitude,
          lng: element.lastMessage.gPRMC.longitude,
          arrived: element.arrived,
          departed: element.departed,
          parked: element.parked,
          address: element.address,
          assetName: element.assetName,
          name: element.positionName,
          fridge: element.lastMessage.iO1 == 1 ? "On" : "Off",
          tempA: element.lastMessage.sensorAValue,
          tempB: element.lastMessage.sensorBValue,
        };
        subTripPoints.push(obj);
      }
    });
    this.setState({ subTripPoints });
  };

  setVisitMapPoints = (data, start, end, tripMapObjects) => {
    var visitMapPoints = [];

    if (start && start.latitude && start.longitude) {
      visitMapPoints.push({
        lat: start.latitude,
        lng: start.longitude,
        angle: start.heading,
        name: start.positionName,
        assetName: start.assetName,
        address: start.address,
        parked: start.parked,
        speed: start.speed,
        recieved: start.received || start.recieved,
      });
    }

    data.forEach((subTrip) => {
      (subTrip.tripMapPoints || []).forEach((single, index) => {
        if (index == 0) {
          const pointObj = {
            lat: single.latitude,
            lng: single.longitude,
            angle: single.heading,
            name: start.positionName,
            assetName: start.assetName,
            address: start.address,
            parked: start.parked,
            speed: start.speed,
            recieved: start.received,
          };
          visitMapPoints.push(pointObj);
        } else {
          const pointObj = {
            lat: single.latitude,
            lng: single.longitude,
            angle: single.heading,
          };
          visitMapPoints.push(pointObj);
        }
      });
    });

    if (visitMapPoints.length <= 1 && tripMapObjects && tripMapObjects.length > 0) {
      tripMapObjects.forEach((tripObject) => {
        if (tripObject.lastMessage && tripObject.lastMessage.gPRMC) {
          visitMapPoints.push({
            lat: tripObject.lastMessage.gPRMC.latitude,
            lng: tripObject.lastMessage.gPRMC.longitude,
            angle: tripObject.lastMessage.gPRMC.heading,
            name: tripObject.positionName,
            assetName: tripObject.assetName,
            address: tripObject.address,
            parked: tripObject.parked,
            speed: tripObject.lastMessage.gPRMC.speed,
            recieved: tripObject.lastMessage.received || tripObject.lastMessage.created,
          });
        }
      });
    }

    if (end && end.latitude && end.longitude) {
      visitMapPoints.push({
        lat: end.latitude,
        lng: end.longitude,
        angle: end.heading,
        name: end.positionName,
        assetName: end.assetName,
        address: end.address,
        parked: end.parked,
        speed: end.speed,
        recieved: end.received || end.recieved,
      });
    }

    this.setState({ visitMapPoints });
  };

  render() {
    const selectStyles = {
      control: (base, state) => ({
        ...base,
        minHeight: 44,
        backgroundColor: "#f8fafc",
        borderColor: state.isFocused ? "#244b8f" : "#dbe4ef",
        borderRadius: 8,
        boxShadow: state.isFocused ? "0 0 0 2px rgba(36, 75, 143, 0.14)" : "none",
        "&:hover": {
          borderColor: state.isFocused ? "#244b8f" : "#aebdd0",
        },
      }),
      indicatorSeparator: (base) => ({
        ...base,
        backgroundColor: "#dbe4ef",
      }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? "#244b8f" : state.isFocused ? "#edf3fb" : "#fff",
        color: state.isSelected ? "#fff" : "#26354f",
        fontSize: 13,
      }),
      placeholder: (base) => ({
        ...base,
        color: "#7e8da1",
      }),
      singleValue: (base) => ({
        ...base,
        color: "#17233c",
        fontWeight: 700,
      }),
      menu: (base) => ({
        ...base,
        zIndex: 200,
        borderRadius: 8,
        overflow: "hidden",
      }),
    };

    const groupOptions = this.state.groupDetails.map((group) => ({
      value: group.groupId,
      label: `${group.customername} - ${group.groupName}`,
      data: group,
    }));

    const selectedGroupOption =
      groupOptions.find((option) => option.value == this.state.groupId) || null;

    const assetOptions = this.state.AssetList.map((asset) => ({
      value: asset.assetId,
      label: `${asset.name}${asset.customerName ? ` - ${asset.customerName}` : ""}`,
      data: asset,
    }));

    const selectedAssetOption =
      assetOptions.find((option) => option.value == this.state.assetId) ||
      (this.state.assetId
        ? {
            value: this.state.assetId,
            label: this.state.assetPlaceholder,
            data: {
              assetId: this.state.assetId,
              name: this.state.assetPlaceholder,
              customerName: this.state.assetGeneralName,
            },
          }
        : null);
    const loadedReportParams = this.state.loadedReportParams;
    const hasPendingReportChanges = !!(
      loadedReportParams &&
      this.state.assetId &&
      (
        loadedReportParams.assetId !== this.state.assetId ||
        loadedReportParams.reportDate !== this.state.ReportDate ||
        (loadedReportParams.groupId || "") !== (this.state.groupId || "") ||
        loadedReportParams.checked !== this.state.checked
      )
    );

    const calendarReport = this.state.calendarShow ? (
      <div ref={this.setWrapperRef} className="ParentCalender" style={{ position: "relative", zIndex: 100 }}>
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar maxDate={new Date()} onChange={this.onChangeDate} value={this.state.calendarSelectedDate} />
        </div>
      </div>
    ) : (
      ""
    );

    return (
      <Layout>
        <Helmet>
          <title>Visit Report</title>
        </Helmet>
        <div className="contentBody">
          <div className={!this.props.headerHide ? `contentWrapper contentWrapperSmoothRelease report-modern-page visit-report-page` : `contentWrapper contentWrapperSmooth report-modern-page visit-report-page`}>
            <div className="reportHeaderTile">
              <div className="headingContainer report-modern-header">
                <div>
                  <h2 className="mainHeading">
                    Visit Report
                  </h2>
                  <p>Review visits, mapped stops, exceptions and raw events for a selected asset and day.</p>
                </div>
                <i className={this.props.headerHide ? `fa fa-window-restore` : `fa fa-window-maximize`} onClick={this.handleWindow} />
              </div>
              <div className="inputFormGroup reportPickerGrid reportPickerToolbar">
                <div className="reportQuickActions">
                  <span className="reportQuickActionsLabel">Quick reports</span>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Rpt-MVTL")}>MVTL</button>
                  <button type="button" className="active" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Rpt-Visit")}>Visit</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Temperature")}>Temp</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Replay")}>Replay</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Rpt-LocationData")}>Location</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Timeline")}>Timeline</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Track")}>Track</button>
                  <span className="reportQuickActionsSpacer" />
                  <label
                    className="reportFilterSwitch"
                    title="When enabled, this report starts from the first trip that leaves the depot and removes earlier trip, virtual trip, parked, and sub-trip records."
                  >
                    <input type="checkbox" onChange={this.handleCheckup} checked={this.state.checked} />
                    <span className="reportFilterSwitchTrack" aria-hidden="true">
                      <span className="reportFilterSwitchThumb" />
                    </span>
                    <span className="reportFilterSwitchText">Use Filtering</span>
                    <span className="reportFilterHelp" aria-hidden="true">?</span>
                  </label>
                </div>
                <div className="inputElement reportPickerField">
                  <label>Group</label>
                  <Select
                    value={selectedGroupOption}
                    options={groupOptions}
                    styles={selectStyles}
                    onChange={this.handleGroupSelection}
                    isClearable
                    isSearchable
                    placeholder="Search group"
                    noOptionsMessage={() => "No groups found"}
                  />
                  {this.state.isLoading && (
                    <GroupWarning
                      warningText={true}
                      warningTextHead="No Groups Found"
                      warningTextBody=" You do not have any group memberships. Please contact Support to ensure your account configured correctly."
                    />
                  )}
                </div>
                <div className="inputElement reportPickerField">
                  <label>Asset</label>
                  <Select
                    value={selectedAssetOption}
                    options={assetOptions}
                    styles={selectStyles}
                    onChange={this.handleAssetSelection}
                    isClearable
                    isSearchable
                    isDisabled={!this.state.groupId && !this.state.assetId}
                    isLoading={this.state.assetLoader && this.state.groupId != ""}
                    placeholder={this.state.groupId ? "Search asset" : "Select group first"}
                    noOptionsMessage={() => "No assets found"}
                  />
                </div>
                <div className="inputElement reportPickerField">
                  <label>Date</label>
                  <ReportButtonGroup
                    function={this.calendarFunction}
                    dropDown={calendarReport}
                    placeholder={this.state.dataPlaceholder}
                    icon="fa-calendar"
                  />
                </div>
                <div className="inputElement reportPickerActions">
                  {this.state.assetId != "" ? (
                    <Button className={hasPendingReportChanges ? "reportPickerCreateButton report-create-pending" : "reportPickerCreateButton"} variant="primary" onClick={this.handleCreateReport} size="sm">
                      <i className="fa fa-map-marker"></i>
                      Create Report
                    </Button>
                  ) : (
                    <Button className="reportPickerCreateButton" variant="primary" onClick={this.handleCreateReport} size="sm" disabled>
                      <i className="fa fa-map-marker"></i>
                      Create Report
                    </Button>
                  )}
                </div>
              </div>
            </div>
            <TimeZoneConvert />
            {this.state.assetSelectionBoolean ? (
              <div className="reportBody">
                {this.state.reportLoader ? (
                  <div className="loaderLine">
                    <br /> <GridLoader size={7} color={"#222222"} loading={this.state.reportLoader} />
                    <h1> &nbsp;Generating Report</h1>
                    <br />
                  </div>
                ) : this.state.errorLoader ? (
                  <AssetInforWarning warningText={true} warningTextMsg={this.state.errorMessage || "No Data Available"} />
                ) : (
                  <React.Fragment>
                    {this.state.reportDetails.processed != 0 ? (
                      <React.Fragment>
                        <Summary reportDetail={this.state.reportDetails} generatedDate={this.state.generatedDate} />
                        <VisitMap
                          depot={this.state.reportDetails.depot}
                          visitMapPoints={this.state.visitMapPoints}
                          subTripPoints={this.state.subTripPoints}
                        />
                        {this.state.reportDetails.trips != null && this.state.reportDetails.trips.length > 0 && (
                          <VisitLog
                            reportDetail={this.state.reportDetails.trips}
                            assetCustomerName={this.state.assetPlaceholder}
                            calendarSelectedDate={this.state.calendarSelectedDate}
                            tempAEnabled={this.state.reportDetails.tempA}
                            tempBEnabled={this.state.reportDetails.tempB}
                            driverIDEnabled={this.state.reportDetails.driverID}
                            assetId={this.state.assetId}
                          />
                        )}
                        {this.state.reportDetails.speedExceptions != null && this.state.reportDetails.speedExceptions.length > 0 && (
                          <OverSpeedException
                            reportDetail={this.state.reportDetails.speedExceptions}
                            assetCustomerName={this.state.assetPlaceholder}
                            calendarSelectedDate={this.state.calendarSelectedDate}
                          />
                        )}
                        {this.state.reportDetails.rawMessagesEvents != null && this.state.reportDetails.rawMessagesEvents.length > 0 && (
                          <RawMessagesEvents
                            reportDetail={this.state.reportDetails.rawMessagesEvents}
                            assetCustomerName={this.state.assetPlaceholder}
                            calendarSelectedDate={this.state.calendarSelectedDate}
                            tempAEnabled={this.state.reportDetails.tempA}
                            tempBEnabled={this.state.reportDetails.tempB}
                            driverIDEnabled={this.state.reportDetails.driverID}
                            assetId={this.state.assetId}
                          />
                        )}
                      </React.Fragment>
                    ) : (
                      <AssetInforWarning warningText={true} warningTextMsg="No Data Available" />
                    )}
                  </React.Fragment>
                )}
              </div>
            ) : (
              <AssetInforWarning />
            )}
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
  reportAssetId: state.reportAssetId,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setHeaderVisibleAction: setHeaderVisible,
  setReportAssetIdAction: setReportAssetId,
  setReportCalendatDateAction: setReportCalendatDate,
  setReportAssetNameAction: setReportAssetName,
  setReportGroupIdAction: setReportGroupId,
};

export default connect(mapStateToProps, mapDispatchToProps)(Visit);
